"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositUpsellContentType = exports.SubmitMobileCheckDepositErrorCode = exports.PRE_GALILEO_OUTBOUND_CHANNELS = exports.DepositOutboundChannel = exports.ReviewCenterTransactionStatus = exports.DepositIncomingWirePaymentStatus = exports.DepositWireVelocityCheckResult = exports.DEPOSIT_WIRE_TRANSFER_CANCELLABLE_STATUSES = exports.DepositWireTransferStatus = exports.BillPayFraudReason = exports.CreateBillPayPaymentErrorCode = exports.AddBillPayBillerErrorCode = exports.DepositBillPayRecurringConfigStatus = exports.DepositBillPayPaymentFrequency = exports.DepositBillPayPaymentStatus = exports.DepositBillPayPaymentMethod = exports.DepositAchTransferStatus = exports.DepositAchTransferType = exports.DepositScheduledAchTransferStatus = exports.DepositRecurringAchTransferStatus = exports.DepositCardReplacementStatus = exports.DepositTransactionCardEntry = exports.AchInstitutionRole = exports.DepositTransactionRail = exports.isTransactionPending = exports.TransactionStatus = exports.TRANSACTION_FETCH_OPTION_KEYS = exports.TransactionDirection = exports.DepositAchErrorCode = void 0;
var DepositAchErrorCode;
(function (DepositAchErrorCode) {
    DepositAchErrorCode["INSUFFICIENT_EXTERNAL_ACCOUNT_BALANCE"] = "INSUFFICIENT_EXTERNAL_ACCOUNT_BALANCE";
    DepositAchErrorCode["EXTERNAL_ACCOUNT_BALANCE_UNAVAILABLE"] = "EXTERNAL_ACCOUNT_BALANCE_UNAVAILABLE";
})(DepositAchErrorCode || (exports.DepositAchErrorCode = DepositAchErrorCode = {}));
var TransactionDirection;
(function (TransactionDirection) {
    TransactionDirection["OUTGOING"] = "OUTGOING";
    TransactionDirection["INCOMING"] = "INCOMING";
})(TransactionDirection || (exports.TransactionDirection = TransactionDirection = {}));
// Single source of truth for which options get projected down to the rails. The satisfies makes a new
// TransactionFetchOptions key a compile error here until it's listed, and rejects a post-merge key listed by mistake.
const TRANSACTION_FETCH_OPTION_KEY_SET = {
    excludeBackedOut: true,
    excludeDenied: true,
    excludeReturned: true,
    excludeCancelled: true,
    fromDate: true,
    toDate: true,
};
exports.TRANSACTION_FETCH_OPTION_KEYS = Object.keys(TRANSACTION_FETCH_OPTION_KEY_SET);
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["pending"] = "pending";
    TransactionStatus["success"] = "success";
    TransactionStatus["cancelled"] = "cancelled";
    TransactionStatus["returned"] = "returned";
    TransactionStatus["denied"] = "denied";
    TransactionStatus["backedOut"] = "backedOut";
    TransactionStatus["failed"] = "failed";
    TransactionStatus["reversed"] = "reversed";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
/** Pendingness is derived from status, not carried beside it, so the two can never disagree. */
const isTransactionPending = (transaction) => transaction.status === TransactionStatus.pending;
exports.isTransactionPending = isTransactionPending;
// Rails are mutually exclusive transaction categories. Rows are classified into exactly one rail
// by depositGetAllTransactionsModule (priority: fee > debit > ach > other).
// populated rows from the wire, bill and mobile check deposit modules are merged at the coordinator by their IDs
var DepositTransactionRail;
(function (DepositTransactionRail) {
    DepositTransactionRail["ach"] = "ach";
    DepositTransactionRail["bill"] = "bill";
    DepositTransactionRail["debit"] = "debit";
    DepositTransactionRail["wire"] = "wire";
    DepositTransactionRail["mobileCheckDeposit"] = "mobileCheckDeposit";
    DepositTransactionRail["fee"] = "fee";
    DepositTransactionRail["other"] = "other";
})(DepositTransactionRail || (exports.DepositTransactionRail = DepositTransactionRail = {}));
var AchInstitutionRole;
(function (AchInstitutionRole) {
    AchInstitutionRole["odfi"] = "odfi";
    AchInstitutionRole["rdfi"] = "rdfi";
})(AchInstitutionRole || (exports.AchInstitutionRole = AchInstitutionRole = {}));
var DepositTransactionCardEntry;
(function (DepositTransactionCardEntry) {
    DepositTransactionCardEntry["pinEntered"] = "pinEntered";
    DepositTransactionCardEntry["noPinEntered"] = "noPinEntered";
})(DepositTransactionCardEntry || (exports.DepositTransactionCardEntry = DepositTransactionCardEntry = {}));
var DepositCardReplacementStatus;
(function (DepositCardReplacementStatus) {
    DepositCardReplacementStatus["LOST"] = "L";
    DepositCardReplacementStatus["STOLEN"] = "S";
})(DepositCardReplacementStatus || (exports.DepositCardReplacementStatus = DepositCardReplacementStatus = {}));
// ============================================================================
// Recurring/Scheduled ACH Transfer Enums
// ============================================================================
var DepositRecurringAchTransferStatus;
(function (DepositRecurringAchTransferStatus) {
    DepositRecurringAchTransferStatus["active"] = "active";
    DepositRecurringAchTransferStatus["paused"] = "paused";
    DepositRecurringAchTransferStatus["disabled"] = "disabled";
})(DepositRecurringAchTransferStatus || (exports.DepositRecurringAchTransferStatus = DepositRecurringAchTransferStatus = {}));
var DepositScheduledAchTransferStatus;
(function (DepositScheduledAchTransferStatus) {
    DepositScheduledAchTransferStatus["scheduled"] = "scheduled";
    DepositScheduledAchTransferStatus["completed"] = "completed";
    DepositScheduledAchTransferStatus["cancelled"] = "cancelled";
    DepositScheduledAchTransferStatus["failed"] = "failed";
})(DepositScheduledAchTransferStatus || (exports.DepositScheduledAchTransferStatus = DepositScheduledAchTransferStatus = {}));
var DepositAchTransferType;
(function (DepositAchTransferType) {
    DepositAchTransferType["instant"] = "instant";
    DepositAchTransferType["recurring"] = "recurring";
    DepositAchTransferType["scheduledOneTime"] = "scheduledOneTime";
})(DepositAchTransferType || (exports.DepositAchTransferType = DepositAchTransferType = {}));
var DepositAchTransferStatus;
(function (DepositAchTransferStatus) {
    DepositAchTransferStatus["initiated"] = "initiated";
    DepositAchTransferStatus["underReview"] = "underReview";
    DepositAchTransferStatus["pending"] = "pending";
    DepositAchTransferStatus["sent"] = "sent";
    DepositAchTransferStatus["completed"] = "completed";
    DepositAchTransferStatus["returned"] = "returned";
    DepositAchTransferStatus["cancelled"] = "cancelled";
    DepositAchTransferStatus["failed"] = "failed";
})(DepositAchTransferStatus || (exports.DepositAchTransferStatus = DepositAchTransferStatus = {}));
// ============================================================================
// Bill Pay Enums
// ============================================================================
var DepositBillPayPaymentMethod;
(function (DepositBillPayPaymentMethod) {
    DepositBillPayPaymentMethod["electronic"] = "electronic";
    DepositBillPayPaymentMethod["paper"] = "paper";
})(DepositBillPayPaymentMethod || (exports.DepositBillPayPaymentMethod = DepositBillPayPaymentMethod = {}));
var DepositBillPayPaymentStatus;
(function (DepositBillPayPaymentStatus) {
    DepositBillPayPaymentStatus["scheduled"] = "scheduled";
    DepositBillPayPaymentStatus["under_review"] = "under_review";
    DepositBillPayPaymentStatus["processing"] = "processing";
    DepositBillPayPaymentStatus["completed"] = "completed";
    DepositBillPayPaymentStatus["failed"] = "failed";
    DepositBillPayPaymentStatus["canceled"] = "canceled";
    DepositBillPayPaymentStatus["rejected"] = "rejected";
    DepositBillPayPaymentStatus["expired"] = "expired";
    DepositBillPayPaymentStatus["mailed"] = "mailed";
    DepositBillPayPaymentStatus["cleared"] = "cleared";
    DepositBillPayPaymentStatus["refunded"] = "refunded";
})(DepositBillPayPaymentStatus || (exports.DepositBillPayPaymentStatus = DepositBillPayPaymentStatus = {}));
var DepositBillPayPaymentFrequency;
(function (DepositBillPayPaymentFrequency) {
    DepositBillPayPaymentFrequency["one_time"] = "one_time";
    DepositBillPayPaymentFrequency["monthly"] = "monthly";
})(DepositBillPayPaymentFrequency || (exports.DepositBillPayPaymentFrequency = DepositBillPayPaymentFrequency = {}));
var DepositBillPayRecurringConfigStatus;
(function (DepositBillPayRecurringConfigStatus) {
    DepositBillPayRecurringConfigStatus["active"] = "active";
    DepositBillPayRecurringConfigStatus["paused"] = "paused";
    DepositBillPayRecurringConfigStatus["disabled"] = "disabled";
})(DepositBillPayRecurringConfigStatus || (exports.DepositBillPayRecurringConfigStatus = DepositBillPayRecurringConfigStatus = {}));
var AddBillPayBillerErrorCode;
(function (AddBillPayBillerErrorCode) {
    AddBillPayBillerErrorCode["duplicateBiller"] = "duplicate_biller";
    AddBillPayBillerErrorCode["invalidAccountNumber"] = "invalid_account_number";
})(AddBillPayBillerErrorCode || (exports.AddBillPayBillerErrorCode = AddBillPayBillerErrorCode = {}));
var CreateBillPayPaymentErrorCode;
(function (CreateBillPayPaymentErrorCode) {
    CreateBillPayPaymentErrorCode["billerNotFound"] = "biller_not_found";
    CreateBillPayPaymentErrorCode["invalidAmount"] = "invalid_amount";
    CreateBillPayPaymentErrorCode["invalidDate"] = "invalid_date";
    CreateBillPayPaymentErrorCode["executionFailed"] = "execution_failed";
    CreateBillPayPaymentErrorCode["insufficientBalance"] = "insufficient_balance";
    CreateBillPayPaymentErrorCode["duplicateRecurringConfig"] = "duplicate_recurring_config";
    CreateBillPayPaymentErrorCode["fraudRejected"] = "fraud_rejected";
})(CreateBillPayPaymentErrorCode || (exports.CreateBillPayPaymentErrorCode = CreateBillPayPaymentErrorCode = {}));
var BillPayFraudReason;
(function (BillPayFraudReason) {
    BillPayFraudReason["accountTooNew"] = "account_too_new";
    BillPayFraudReason["accountNotActive"] = "account_not_active";
    BillPayFraudReason["exceedsSinglePaymentLimit"] = "exceeds_single_payment_limit";
    BillPayFraudReason["exceedsDailyLimit"] = "exceeds_daily_limit";
    BillPayFraudReason["bsaAmlStructuringSuspicion"] = "bsa_aml_structuring_suspicion";
    BillPayFraudReason["velocityLimitExceeded"] = "velocity_limit_exceeded";
    BillPayFraudReason["duplicatePayment"] = "duplicate_payment";
    BillPayFraudReason["paperCheckPayment"] = "paper_check_payment";
})(BillPayFraudReason || (exports.BillPayFraudReason = BillPayFraudReason = {}));
// ============================================================================
// Wire Transfer Enums
// ============================================================================
var DepositWireTransferStatus;
(function (DepositWireTransferStatus) {
    DepositWireTransferStatus["initiated"] = "initiated";
    DepositWireTransferStatus["pendingOtp"] = "pendingOtp";
    DepositWireTransferStatus["confirmed"] = "confirmed";
    DepositWireTransferStatus["pendingReview"] = "pendingReview";
    DepositWireTransferStatus["approved"] = "approved";
    DepositWireTransferStatus["submittedToCcb"] = "submittedToCcb";
    DepositWireTransferStatus["completed"] = "completed";
    DepositWireTransferStatus["failed"] = "failed";
    DepositWireTransferStatus["cancelled"] = "cancelled";
    DepositWireTransferStatus["rejected"] = "rejected";
})(DepositWireTransferStatus || (exports.DepositWireTransferStatus = DepositWireTransferStatus = {}));
exports.DEPOSIT_WIRE_TRANSFER_CANCELLABLE_STATUSES = [
    DepositWireTransferStatus.initiated,
    DepositWireTransferStatus.pendingOtp,
    DepositWireTransferStatus.confirmed,
    DepositWireTransferStatus.pendingReview,
];
// ============================================================================
// Wire Transfer Velocity Check Types
// ============================================================================
var DepositWireVelocityCheckResult;
(function (DepositWireVelocityCheckResult) {
    DepositWireVelocityCheckResult["allowed"] = "allowed";
    DepositWireVelocityCheckResult["blocked"] = "blocked";
    DepositWireVelocityCheckResult["rejected"] = "rejected";
})(DepositWireVelocityCheckResult || (exports.DepositWireVelocityCheckResult = DepositWireVelocityCheckResult = {}));
var DepositIncomingWirePaymentStatus;
(function (DepositIncomingWirePaymentStatus) {
    DepositIncomingWirePaymentStatus["pending"] = "pending";
    DepositIncomingWirePaymentStatus["posted"] = "posted";
    DepositIncomingWirePaymentStatus["reversed"] = "reversed";
    DepositIncomingWirePaymentStatus["failed"] = "failed";
    DepositIncomingWirePaymentStatus["manualReview"] = "manualReview";
    // A matched incoming wire that is awaiting an ops approve/reject decision before it touches the ledger.
    // Approve flips it pending then posts to Galileo; reject flips it to `returned` and generates a return file.
    DepositIncomingWirePaymentStatus["pendingApproval"] = "pendingApproval";
    // An incoming wire that ops rejected and we are returning to the originating bank.
    DepositIncomingWirePaymentStatus["returned"] = "returned";
})(DepositIncomingWirePaymentStatus || (exports.DepositIncomingWirePaymentStatus = DepositIncomingWirePaymentStatus = {}));
// ============================================================================
// Mobile Check Deposit
// ============================================================================
var ReviewCenterTransactionStatus;
(function (ReviewCenterTransactionStatus) {
    ReviewCenterTransactionStatus["received"] = "Received";
    ReviewCenterTransactionStatus["accepted"] = "Accepted";
    ReviewCenterTransactionStatus["rejected"] = "Rejected";
    ReviewCenterTransactionStatus["needsReview"] = "NeedsReview";
    ReviewCenterTransactionStatus["inProcess"] = "InProcess";
    ReviewCenterTransactionStatus["feeReview"] = "FeeReview";
    ReviewCenterTransactionStatus["feeAccepted"] = "FeeAccepted";
    ReviewCenterTransactionStatus["feeRejected"] = "FeeRejected";
    ReviewCenterTransactionStatus["fundingTypeReview"] = "FundingTypeReview";
    ReviewCenterTransactionStatus["fundingTypeAccepted"] = "FundingTypeAccepted";
    ReviewCenterTransactionStatus["fundingTypeRejected"] = "FundingTypeRejected";
    ReviewCenterTransactionStatus["canceled"] = "Canceled";
    ReviewCenterTransactionStatus["checkFeeCanceled"] = "CheckFeeCanceled";
    ReviewCenterTransactionStatus["proccessCheckCanceled"] = "ProccessCheckCanceled";
    ReviewCenterTransactionStatus["fundingTypeInProcess"] = "FundingTypeInProcess";
    ReviewCenterTransactionStatus["validationFailed"] = "ValidationFailed";
    ReviewCenterTransactionStatus["validationSucceeded"] = "ValidationSucceeded";
    ReviewCenterTransactionStatus["manualSelect"] = "ManualSelect";
    ReviewCenterTransactionStatus["imageProcessingFailed"] = "ImageProcessingFailed";
    ReviewCenterTransactionStatus["imageProcessingSucceeded"] = "ImageProcessingSucceeded";
    ReviewCenterTransactionStatus["userActionRequired"] = "UserActionRequired";
})(ReviewCenterTransactionStatus || (exports.ReviewCenterTransactionStatus = ReviewCenterTransactionStatus = {}));
/**
 * All channels through which funds can leave a deposit account. Used by the
 * depositPendingOutboundExceedsBalanceRunner to exhaustively cover outbound paths.
 * If you add a new outbound channel, add it here and update the runner.
 */
var DepositOutboundChannel;
(function (DepositOutboundChannel) {
    DepositOutboundChannel["wire"] = "wire";
    DepositOutboundChannel["billPay"] = "billPay";
    DepositOutboundChannel["ach"] = "ach";
    DepositOutboundChannel["debitCard"] = "debitCard";
})(DepositOutboundChannel || (exports.DepositOutboundChannel = DepositOutboundChannel = {}));
/** Outbound channels that have pending states NOT yet reflected in the Galileo balance */
exports.PRE_GALILEO_OUTBOUND_CHANNELS = [DepositOutboundChannel.wire, DepositOutboundChannel.billPay];
var SubmitMobileCheckDepositErrorCode;
(function (SubmitMobileCheckDepositErrorCode) {
    SubmitMobileCheckDepositErrorCode["mobileCheckDepositNotEnabled"] = "mobileCheckDepositNotEnabled";
    SubmitMobileCheckDepositErrorCode["invalidImageFormat"] = "invalidImageFormat";
    SubmitMobileCheckDepositErrorCode["invalidAmount"] = "invalidAmount";
    SubmitMobileCheckDepositErrorCode["amountExceedsLimit"] = "amountExceedsLimit";
    SubmitMobileCheckDepositErrorCode["reviewCenterUserCreationFailed"] = "reviewCenterUserCreationFailed";
    SubmitMobileCheckDepositErrorCode["reviewCenterSubmissionFailed"] = "reviewCenterSubmissionFailed";
    SubmitMobileCheckDepositErrorCode["duplicateCheck"] = "duplicateCheck";
    SubmitMobileCheckDepositErrorCode["checkRejected"] = "checkRejected";
})(SubmitMobileCheckDepositErrorCode || (exports.SubmitMobileCheckDepositErrorCode = SubmitMobileCheckDepositErrorCode = {}));
// Selects which approved content variant the upsell campaign targets a customer with; the comms and
// the in-app card render from the same variant so a customer never sees copy they weren't sent.
var DepositUpsellContentType;
(function (DepositUpsellContentType) {
    DepositUpsellContentType["homeUpsellDefault"] = "homeUpsellDefault";
    DepositUpsellContentType["avenCashChecking"] = "avenCashChecking";
})(DepositUpsellContentType || (exports.DepositUpsellContentType = DepositUpsellContentType = {}));
